<template>
  <div class="myfooter">
    <img class="topImg" src="@/assets/home/bottomImg.png" alt="" />
    <!-- 页脚链接区（五大栏目 + 订阅号二维码 + 网上举报）按要求隐藏，保留下方版权备案条 -->
    <!-- <div class="main" :style="{ background: bgColor }">
      <div>
        <ul class="left">
          <li
            v-for="(item, index) of xxList"
            :key="index"
            :class="index === 5 ? 'aboutUs' : ''"
          >
            <span :style="{ color: textColor }">{{ item.name }}</span>
            <div>
              <span
                :style="{ color: textColor, cursor: 'pointer' }"
                v-for="(ele, index2) of item.child"
                @click="goUrl(ele.url)"
                :key="index2"
                >{{ ele.name }}</span
              >
            </div>
          </li>
          <li>
            <span :style="{ color: textColor }">友情链接</span>
            <div>
              <span
                :style="{ color: textColor, cursor: 'pointer' }"
                v-for="(ele, index2) of linkList.slice(0, 7)"
                @click="openWindow(ele.linkUrl)"
                :key="index2"
                >{{ ele.linkName }}</span
              >
              <span class="moreBtn" v-if="linkList.length > 6"
                >更多 <img src="@/assets/text/moreBtn.png" alt=""
              /></span>
            </div>
          </li>
        </ul>
        <div class="right">
          <div class="box1">
            <div><img src="@/assets/home/dyh.png" alt="" /></div>
            <span :style="{ color: textColor }">订阅号</span>
          </div>
          <div
            class="box2"
            @click="openWindow('http://jb.zjmegroup.cn:38445/')"
          >
            <img src="@/assets/home/wsjb.png" alt="" />
            <span :style="{ color: textColor }">网上举报</span>
          </div>
        </div>
      </div>
    </div> -->
    <CopyrightModule :data="footerInfo" />
    <div class="bottom" :style="{ background: bottombgColor }">
      <!-- <div>
        <p :style="{ color: textColor }">
          CopyRight © 2020 zjmegroup.cn 浙江省机电集团有限公司 All Rights
          Reserved.
        </p>
        <div>
          <p :style="{ color: textColor }">
            联系电话：{{ footerInfo.tel || "" }}
          </p>
          <p :style="{ color: textColor }">
            E-Mail: {{ footerInfo.email || "" }}
          </p>
          <p :style="{ color: textColor }">浙ICP备14033092号-1</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import api from "@/api/api";
// 组件
import CopyrightModule from "./copyright.vue";
const router = useRouter();
const xxList = ref([
  {
    name: "集团概况",
    url: "/groupOverview?chooseKey=1",
    child: [
      {
        name: "集团简介",
        url: "/groupOverview?chooseKey=1",
      },
      {
        name: "领导班子",
        url: "/groupOverview?chooseKey=2",
      },
      {
        name: "组织架构",
        url: "/groupOverview?chooseKey=3",
      },
      {
        name: "集团荣誉",
        url: "/groupOverview?chooseKey=4",
      },
    ],
  },
  {
    name: "新闻中心",
    url: "/newsCenter?id=4",
    child: [
      {
        name: "领导关怀",
        url: "/newsCenter?id=4",
      },
      {
        name: "集团要闻",
        url: "/newsCenter?id=1",
      },
      {
        name: "成员动态",
        url: "/newsCenter?id=2",
      },
    ],
  },
  {
    name: "板块业务",
    url: "/blockBusiness?id=126",
    child: [
      {
        name: "新能源板块",
        url: "/blockBusiness?id=126",
      },
      {
        name: "航空航天复材制造板块",
        url: "/blockBusiness?id=129",
      },
      {
        name: "海洋船舶及相关制造",
        url: "/blockBusiness?id=159",
      },
      {
        name: "其他装备制造板块",
        url: "/blockBusiness?id=169",
      },
      {
        name: "工美文化",
        url: "/blockBusiness?id=164",
      },
      {
        name: "军工板块",
        url: "/blockBusiness?id=135",
      },
      {
        name: "民爆板块",
        url: "/blockBusiness?id=132",
      },
      {
        name: "产业服务板块",
        url: "/blockBusiness?id=174",
      },
    ],
  },
  {
    name: "信息公开",
    url: "/informationOpen?id=1",
    showChild: false,
    child: [
      {
        name: "人才招聘",
        url: "/informationOpen?id=1",
      },
      {
        name: "公示公告",
        url: "/informationOpen?id=2",
      },
      {
        name: "联系我们",
        url: "/informationOpen?id=4",
      },
    ],
  },
]);
const bgColor = ref("#2A2A2A");
const bottombgColor = ref("#575757");
const textColor = ref("#FFFFFF");
const route = useRoute();
const linkList = ref([]);
const goUrl = (url) => {
  if (url) {
    router.push(url);
  }
};
const openWindow = (url) => {
  window.open(url, "_blank");
};
const getValue = async () => {
  let { code, res } = await api.getFriendshipLink();
  if (code === "0") {
    linkList.value = res.data;
  }
  console.log(res, "res--------");
};
const footerInfo = ref({});
const getFootValue = async () => {
  try {
    const res = await api.getPageConfigDetail(69);
    if (res.code == "0") {
      footerInfo.value = res.res.data || {};
    }
  } catch (error) {}
};
watch(
  () => route,
  (initInfo, prevInitInfo) => {
    let path = initInfo.fullPath;
    if (path === "/index") {
      bgColor.value = "#2A2A2A";
      textColor.value = "#FFFFFF";
      bottombgColor.value = "#575757";
    } else {
      bgColor.value = "#F9F9F9";
      textColor.value = "#333333";
      bottombgColor.value = "#F1F1F1";
    }
  },
  { deep: true, immediate: true }
);
onMounted(() => {
  getValue();
  getFootValue();
});
</script>

<style scoped lang="less">
.moreBtn {
  cursor: pointer;
  color: #acc9cd !important;
  display: flex;
  align-items: center;
  img {
    width: 5px;
    height: 9px;
    margin-left: 5px;
  }
}
.myfooter {
  width: 100%;
}
.topImg {
  width: 100%;
  display: block;
}
.main {
  width: 100%;
  height: 426px;
  // background: #2A2A2A;
  overflow: hidden;
  & > div {
    margin: 40px auto 0;
    width: 1345px;
    display: flex;
    justify-content: space-between;
    .left {
      // width: 900px;
      flex: 1;
      display: flex;
      margin-left: 10px;
      li {
        display: flex;
        flex-direction: column;
        & > span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #ffffff;
          line-height: 22px;
          text-align: left;
          font-style: normal;
          padding-bottom: 10px;
          border-bottom: 2px solid rgba(170, 170, 170, 0.2);
        }
        div {
          display: flex;
          flex-direction: column;
          margin-top: 17px;
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            margin-top: 20px;
          }
          span:hover {
            color: #009fe8 !important;
          }
        }
      }
      & > li:not(:last-child) {
        flex: 1;
      }
      .aboutUs {
        width: 69px;
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      // align-items: center;
      // justify-content: center;
      margin-left: 6%;
      .box1 {
        display: flex;
        flex-direction: column;
        align-items: center;
        div {
          width: 140px;
          height: 140px;
          background: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 124px;
            height: 124px;
          }
        }
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          line-height: 20px;
          text-align: left;
          font-style: normal;
          margin-top: 11px;
        }
      }
      .box2 {
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: hidden;
        // margin-left: 70px;
        cursor: pointer;
        img {
          width: 104px;
          height: 104px;
          margin-top: 24px;
        }
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          line-height: 20px;
          text-align: left;
          font-style: normal;
          margin-top: 6px;
        }
      }
    }
  }
}
// .bottom {
//   width: 100%;
//   height: 49px;
//   background: #575757;
//   & > div {
//     margin: 0 auto;
//     width: 1345px;
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     div {
//       display: flex;
//       align-items: center;
//       & > p:not(:last-child) {
//         margin-right: 25px;
//       }
//     }
//   }
//   p {
//     font-family: LucidaGrande;
//     font-size: 16px;
//     color: rgba(255, 255, 255, 0.85);
//     line-height: 19px;
//     text-align: left;
//     font-style: normal;
//     line-height: 49px;
//   }
// }
</style>
